/** ISO / Strapi datetime → value for `<input type="datetime-local" />`. */
export function quotationDatetimeLocalFromIso(iso?: string | null): string {
  if (!iso?.trim()) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/** Strapi `date` (`YYYY-MM-DD` or ISO) → value for `<input type="date" />`. */
export function quotationDateInputFromApi(value?: string | null): string {
  if (!value?.trim()) return '';
  const m = /^(\d{4}-\d{2}-\d{2})/.exec(value.trim());
  return m ? m[1] : '';
}

export function quotationDateInputToday(): string {
  const d = new Date();
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

/** `datetime-local` input → ISO string for Strapi, or null when empty/invalid. */
export function quotationIsoFromDatetimeLocal(value: string): string | null {
  const t = value.trim();
  if (!t) return null;
  const d = new Date(t);
  return Number.isNaN(d.getTime()) ? null : d.toISOString();
}
